// Calendar view is session-only. Discard legacy persisted Week state before
// the calendar mounts, so its initial view and first requests agree on Day.
export const calendarPersistence = {
  key: "calendar",
  keyPrefix: "salon-",
  debug: false,
  timeout: 20000,
  whitelist: [],
  migrate: () => Promise.resolve(undefined),
};
